module.exports = __webpack_public_path__ + "static/media/video-faqs.638d14ea.png";